import morphdom from 'morphdom';

export class PDPTemplateSectionReplacement extends HTMLElement {

    constructor() {
      super();

      this.systemProductHandle = window.location.pathname.split('/')[2];
      this.domParser = new DOMParser();
    }

    connectedCallback() {
      this.sectionIndex = this.parentNode
      window.addEventListener('vehicleSelected', this.checkTemplate.bind(this));
      window.addEventListener('variantSelected', this.checkTemplate.bind(this));
    }

    async checkTemplate(event) {
      if (Shopify.designMode) {
        console.log("In design mode, not fetching new template");
        return;
      }

      const productJSONData =  window.__VPV.vehicleData.bySelection || window.__VPV.vehicleData.byVehicle;
      const productHandles = productJSONData.reduce((acc, vehicle) => acc.concat(vehicle.products.map((product) => product.productHandle)), []);
      const uniqueProductHandles = [...new Set(productHandles)];

      console.log("Checking template replacement", this.systemProductHandle, uniqueProductHandles);

      if(!uniqueProductHandles.includes(this.systemProductHandle)){
        console.log('Switching template from ' + this.systemProductHandle + ' to ' + uniqueProductHandles[0]);
        const response = await fetch(`/products/${uniqueProductHandles[0]}`, {
          method: 'GET'
        });
        const responseText = await response.text();
        const newTemplate = this.domParser.parseFromString(responseText, 'text/html');

        const title = newTemplate.querySelector('title');
        if(title){
          document.title = title.innerText;
        }

        

        const allSections = newTemplate.getElementById("main")?.childNodes;

        let afterSectionBreak = false;
        const newSections = Array.from(allSections).filter((section) => {
            if(afterSectionBreak){
                return true;
            }else{
                afterSectionBreak = section.classList && section.classList.contains('shopify-section--replacement-break');
            }
        });

        const main = document.getElementById("main");
        const oldSections = main.childNodes;

        afterSectionBreak = false;
        Array.from(oldSections).filter((section)=>{
            if(afterSectionBreak){
                return true;
            }else{
                afterSectionBreak = section.classList && section.classList.contains('shopify-section--replacement-break');
            }
        }).forEach((section, index) => {
          section.remove();
        });

        newSections.forEach((section, index) => {
          main.appendChild(section);
        });

        //get portals and replace them
        var portals = document.querySelectorAll(".section-replacement-portal");
        portals.forEach((portal) => {
          const newPortal = newTemplate.getElementById(portal.id);
          if(newPortal){
            morphdom(portal, newPortal);
          }
        });


        document.dispatchEvent(new CustomEvent("content:update", {
          bubbles: true,
          detail:{
            context: "template-replacement",
            product: uniqueProductHandles[0]
          }
        }));
        this.systemProductHandle = uniqueProductHandles[0];
      }
    }
}

export class ReplaceableSection extends HTMLElement {
  constructor() {
      super();
      this.sectionId = this.getAttribute('section-id');
      this.productHandle = this.getAttribute('product-handle');
      this.boundOnVariantChanged = this.onVariantChanged.bind(this);
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
  }
  connectedCallback() {
      //console.log("ReplaceableSection connected", this.sectionId);
      window.addEventListener('variant:change', this.boundOnVariantChanged);
      //window.addEventListener('vehicleSelected', this.boundOnVariantChanged);
      if(window.__VPV?.pdp?.remainingVariants?.length === 1){
          this.getSectionData(window.__VPV.pdp.remainingVariants[0].id);
      }
  }
  disconnectedCallback(){
      window.removeEventListener('variant:change', this.boundOnVariantChanged);
      //window.removeEventListener('vehicleSelected', this.boundOnVariantChanged);
  }
  onVariantChanged(event){
      const {variant} = event.detail;
      this.getSectionData(variant?.id);
  }
  async getSectionData(variantId){
      console.log("Getting section data", this.sectionId, this.productHandle, variantId);
      const url = `/products/${this.productHandle}?variant=${variantId}&sections=${this.sectionId}`;
      const response = await fetch(url, {
          method: 'GET'
      });
      const json = await response.json();
      const sectionText = json[this.sectionId];

      morphdom(this.section, sectionText);
      document.dispatchEvent(new CustomEvent("content:update", {
        bubbles: true, 
        detail:{
          context: "section-replacement",
          sectionId: this.sectionId
        }
      }));
  }
}